<template>
  <div v-if="basketKits?.length" class="basket-kits-modal-slider">
    <DefTitle :result="3">
      <h3>{{ title }}</h3>
    </DefTitle>
    <div class="box-modal-tab">
      <span
        v-for="({ active, items, name }, i) in kitsTabs"
        :key="i"
        class="box-modal-tab-item"
        :class="{ 'box-modal-tab-item_active': active }"
        @click="$emit('changeActiveTab', i)"
      >
        {{ name }}
      </span>
    </div>
    <DefSlider :settings="settings" :nav="screenWidth >= 992">
      <div v-for="item in getKits.items" :key="item?.offer?.id ?? item.id" class="swiper-slide">
        <BasketKitsCard
          :result="item"
          :active="activeProduct?.offer?.id == item?.offer?.id || activeProduct?.id == item?.id"
          @click="$emit('changeProduct', item)"
        />
      </div>
    </DefSlider>
  </div>
</template>

<script lang="ts" setup>
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import { reactive, computed, onMounted } from 'vue';
import useScreenWidth from '@use/useScreenWidth';
import BasketKitsCard from '@components/Basket/BasketKits/BasketKitsCard.vue';
import { useStore } from '@/store';

const settings = reactive({
  slidesPerView: 2.3,
  breakpoints: {
    968: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 3,
    },
  },
});
const props = defineProps(['activeProduct', 'kitsTabs']);
const screenWidth = useScreenWidth();

const { state } = useStore();
const basketKits = computed(() => state.basket.data?.kits);
const title = computed(() => state.basket.data.messages.availableKitsTitle);

const getKits = computed(() => props.kitsTabs.find((tab) => tab.active));
</script>

<style lang="scss" scoped>
.basket-kits-modal-slider {
  margin-top: auto;
  padding-top: 24px;
  :deep(.def-slider__prev) {
    left: 0;
    transform: translate(-50%, -50%);
  }
  :deep(.def-slider__next) {
    right: 0;
    transform: translate(50%, -50%);
  }
}
.box-modal-tab {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  text-transform: uppercase;
  color: #3f3f44;
}
.box-modal-tab-item {
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 16px;
  }
  &_active {
    color: var(--color-main);
    text-decoration: underline;
  }
}
</style>
